import { SHOW_EVENTS_FLOW, SHOW_HOURLY_FLOW, SHOW_MONTHLY_FLOW, SHOW_PREPAID_FLOW } from '@booking/constants'
import featureToggles from 'shared/featureToggles'
import { SEARCH_MODE_EVENTS, SEARCH_MODE_HOURLY, SEARCH_MODE_MONTHLY, SEARCH_MODE_PREPAID } from 'search/constants'

export const getSwitchButtons = (defaultCustomerFlow, parkingMode, onClickSwitchTo) => {
    const isHourly = parkingMode === SEARCH_MODE_HOURLY
    const isMonthly = parkingMode === SEARCH_MODE_MONTHLY
    const isEventFlow = parkingMode === SEARCH_MODE_EVENTS && featureToggles.hasEventFlow
    const isPrepaidFlow = parkingMode === SEARCH_MODE_PREPAID && featureToggles.hasPrepaidFlow

    if (!defaultCustomerFlow) return []

    const defaultCustomerFlowArr = defaultCustomerFlow.split('|')

    const switchOptions = [
        {
            component: {
                label: <T>booking.switch.hourly</T>,
                onClick: () => onClickSwitchTo(SEARCH_MODE_HOURLY),
                active: isHourly,
            },
            condition: SHOW_HOURLY_FLOW,
        },
        {
            component: {
                label: <T>booking.switch.monthly</T>,
                onClick: () => onClickSwitchTo(SEARCH_MODE_MONTHLY),
                active: isMonthly,
            },
            condition: SHOW_MONTHLY_FLOW,
        },
        {
            ...(featureToggles.hasPrepaidFlow
                ? {
                      component: {
                          label: <T>booking.switch.prepaid</T>,
                          onClick: () => onClickSwitchTo(SEARCH_MODE_PREPAID),
                          active: isPrepaidFlow,
                      },
                      condition: SHOW_PREPAID_FLOW,
                  }
                : {}),
        },
        {
            ...(featureToggles.hasEventFlow
                ? {
                      component: {
                          label: <T>booking.switch.event</T>,
                          onClick: () => onClickSwitchTo(SEARCH_MODE_EVENTS),
                          active: isEventFlow,
                      },
                      condition: SHOW_EVENTS_FLOW,
                  }
                : {}),
        },
    ]

    const buttonsToRender = []

    for (const option of switchOptions) {
        if (defaultCustomerFlowArr.some(element => option.condition?.includes(element))) {
            buttonsToRender.push(option.component)
        }
    }

    return buttonsToRender
}
